import { cn } from "@/lib/utils";

interface OperatorOptionRowProps {
  operator: string;
  display: string;
  highlighted: boolean;
  disabled?: boolean;
  onSelect?: () => void;
}

const OperatorOptionRow = ({
  operator,
  display,
  highlighted,
  disabled,
  onSelect,
}: OperatorOptionRowProps) => (
  <li
    key={operator}
    role="option"
    aria-selected={highlighted}
    aria-disabled={disabled}
    className={cn(
      "mx-2 mb-1 flex h-[38px] items-center rounded-xl px-3 text-sm transition-colors",
      disabled
        ? "cursor-not-allowed text-slate-400 opacity-70"
        : "cursor-pointer hover:bg-slate-50",
      !disabled && highlighted ? "bg-slate-100 text-slate-900" : undefined,
      !disabled && !highlighted ? "text-slate-700" : undefined,
    )}
    onMouseDown={e => {
      e.preventDefault();
      if (!disabled) {
        onSelect?.();
      }
    }}
  >
    {display}
  </li>
);

export default OperatorOptionRow;
